import React from 'react';
import {
  FileSearchOutlined, MoneyCollectOutlined, CheckCircleOutlined, MobileOutlined,
} from '@ant-design/icons';

/**
 * Icones des indicateurs cles de la liste des sinistres, associees a la CLE de
 * chaque phase et non a sa position : reordonner PHASES_SINISTRE ne doit pas
 * deplacer les icones.
 *
 * Module a part, et non constante locale de ListSinistres.js, pour une raison
 * precise : cette page tire transitivement xlsxShim, qui exige un TextEncoder
 * absent de jsdom, donc aucun test ne peut l'importer. Isolee ici, la table est
 * verifiable -- voir __tests__/iconesPhases.test.js, qui detecte une cle
 * manquante ou orpheline. Sans cela, une faute de frappe ferait disparaitre une
 * icone en silence.
 */
export const ICONE_PHASE = {
  DECLARATION: <MobileOutlined />,
  INSTRUCTION: <FileSearchOutlined />,
  REGLEMENT: <MoneyCollectOutlined />,
  CLOTURE: <CheckCircleOutlined />,
};
